import { Enviroment } from '../../../../_config/constants/enviroment-v2.constant';
import { dictionaryDeliveryInfoColumn } from '../constants/dictionary-delivery-columns.constant';

export const generateHomeDeliveryInfoColumns = () => {
	return [
		{
			title: dictionaryDeliveryInfoColumn[Enviroment.LANGUAGE].region,
			dataIndex: 'region',
			key: 'region',
		},
		{
			title: dictionaryDeliveryInfoColumn[Enviroment.LANGUAGE].commune,
			dataIndex: 'commune',
			key: 'commune',
		},
		{
			title: dictionaryDeliveryInfoColumn[Enviroment.LANGUAGE].municipality,
			dataIndex: 'municipality',
			key: 'municipality',
		},
		{
			title: dictionaryDeliveryInfoColumn[Enviroment.LANGUAGE].address,
			dataIndex: 'street',
			key: 'street',
		},
		{
			title: dictionaryDeliveryInfoColumn[Enviroment.LANGUAGE].hometype,
			dataIndex: 'type_house',
			key: 'type_house',
		},
		{
			title: dictionaryDeliveryInfoColumn[Enviroment.LANGUAGE].floor,
			dataIndex: 'dpto',
			key: 'dpto',
		},
		{
			title: dictionaryDeliveryInfoColumn[Enviroment.LANGUAGE].zip_code,
			dataIndex: 'zip_code',
			key: 'zip_code',
		},
		{
			title: dictionaryDeliveryInfoColumn[Enviroment.LANGUAGE].reference,
			dataIndex: 'reference',
			key: 'reference',
		},
	];
};
